import {get as _get} from 'lodash';

import {getCompetitorsNameFromEvent} from '@utils/competitorName';
import {getStadiumOrVenueNameFromEvent} from '@utils/stadium';
import {getTvChannelNamesFromEvent} from '@utils/tvChannels';

import {getSportName, getTournamentCategoryName, getTournamentName} from '../../utils/eventSchedule';

const tableColumns = {
    start_datetime: {
        label: 'Date / Time',
        header: {align: 'center'},
        sorting: true,
        content: {align: 'center', singleLine: true},
    },
    id: {
        label: 'Event ID',
        header: {align: 'center'},
        sorting: true,
        content: {align: 'center'},
    },
    match_id: {
        label: 'Match ID',
        header: {align: 'center'},
        sorting: (row) => _get(row, 'sr_event.match.id', 0),
        content: {align: 'center'},
    },
    sport_name: {
        label: 'Sport / 1st level category',
        sorting: (row) => getSportName(row),
    },
    category_name: {
        label: 'Category / 2nd level category',
        content: {align: 'left'},
        sorting: (row) => getTournamentCategoryName(row),
    },
    tournament_name: {
        label: 'Tournament / 3rd level category',
        content: {align: 'left'},
        sorting: (row) => getTournamentName(row),
    },
    venue_or_court_or_tvchannel: {
        label: 'Venue / Court / TV Channel',
        content: {align: 'left'},
        sorting: (row) => `${getStadiumOrVenueNameFromEvent(row)} ${getTvChannelNamesFromEvent(row)}`,
    },
    competitors: {
        label: 'Competitors / Description',
        sorting: (row) => getCompetitorsNameFromEvent(row),
    },
    status: {
        label: 'Status',
        sorting: (row) => _get(row, 'event_status.name', ''),
    },
    report_scope: {
        label: 'Report',
        header: {align: 'center'},
        content: {align: 'center'},
    },
    notes: {
        label: 'Notes',
        sorting: false,
    },
};

export default tableColumns;
